import coffeescript from "refractor/coffeescript";
export default coffeescript;